/**
 * @fileoverview The canonical AI output disclaimer.
 *
 * Purpose: Single source of truth for the legal disclaimer shown on every
 * surface that displays AI output, and embedded in every internal artefact
 * the user downloads.
 *
 * Lives in `convex/lib/` rather than `src/lib/` because backend code
 * (`convex/jobs/webSearch/reportPdf.ts`) needs it and Convex cannot import
 * from `src/`. The frontend reaches it via the `@cvx` alias, which is an
 * established pattern here (see `documentCategories.ts`).
 *
 * Plain text, not JSX, so the same value serves React, Word, PDF and Excel.
 *
 * Do NOT paraphrase, truncate or reflow this string. It is approved legal
 * copy, pinned by `aiDisclaimer.test.ts`, and is the short-form restatement
 * of Terms clause 6 (`src/routes/terms.tsx`) — it must not drift from it.
 *
 * Not for outbound documents (creditor/ASIC letters, statutory forms), CSV
 * exports, or AI prefill steps. See
 * docs/superpowers/specs/2026-08-17-ai-output-disclaimer-design.md
 */

export const AI_DISCLAIMER =
  "AI can make mistakes. You agree to verify all information. Morgan makes no warranty as to the accuracy and completeness of any output and does not provide legal or financial advice.";
